var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridViewSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.236 9.736a1 1 0 011 1v4.035a1 1 0 01-1 1H3.2a1 1 0 01-1-1v-4.035a1 1 0 011-1h4.036zm7.535 0a1 1 0 011 1v4.035a1 1 0 01-1 1h-4.035a1 1 0 01-1-1v-4.035a1 1 0 011-1h4.035zM7.236 2.2a1 1 0 011 1v4.036a1 1 0 01-1 1H3.2a1 1 0 01-1-1V3.2a1 1 0 011-1h4.036zm7.535 0a1 1 0 011 1v4.036a1 1 0 01-1 1h-4.035a1 1 0 01-1-1V3.2a1 1 0 011-1h4.035z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewSolid);
export default __webpack_public_path__ + "static/media/GridViewSolid.5df996ee.svg";
export { ForwardRef as ReactComponent };